import Vue from "vue";
import Router from "vue-router";
import Page from "../views/Page.vue";
import Error404page from '../views/Error404page.vue';

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/404",
      name: "four-o-four",
      component: Error404page
    },
    {
      path: "/*",
      name: "pages",
      component: Page,
    },
    // {
    //   path: '/error',
    //   name: 'Error404page',
    //   component: Error404page,
    // }
  ],
  //   scrollBehavior (to, from, savedPosition) {
  //      setTimeout(() => {
  //         return { x: 0, y: 0 };
  //     }, 300);

  // }
  scrollBehavior(to: any, from: any, savedPosition: any) {
    return new Promise((resolve: any, reject: any) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 400);
    });
  },
});
